export const employerTestimonials = [
    {
        name: "Jennifer",
        company: "Visionize",
        quote:
            "Workflow SI by VRM AI Technology completely transformed how we screen candidates for technical roles. The AI-powered phone screening saved us over 60% of our initial interview time. We now focus only on the top candidates who truly matter."
    },
    {
        name: "Venkatesh",
        company: "Galaxy",
        quote:
            "As an offshore company, hiring the right people quickly is critical. Workflow SI ScreenSage automated our first-round calls flawlessly. The transcripts and AI scores helped us shortlist candidates 3x faster than before."
    },
    {
        name: "Varun",
        company: "Tech Ninja",
        quote:
            "As a co-founder, I need tools that scale fast. Workflow SI VideoSage gave us enterprise-grade video interviews without the enterprise price tag. The proctoring and AI evaluation are spot on. Highly recommend it."
    },
    {
        name: "Satish",
        company: "Tech Mahendra",
        quote:
            "The credits-based model is transparent and fair. We only pay for what we use. The AI interview reports are detailed and actionable, and our HR team can now make confident decisions in half the time."
    },
    {
        name: "Shanmugam",
        company: "Healthproof",
        quote:
            "In healthcare, every hire matters. Workflow SI by VRM AI Technology helped us screen candidates with precision and speed. The skill-based evaluation and AI scoring gave us clarity on candidates we would have otherwise missed."
    },
    {
        name: "Laxman",
        company: "Healthedge",
        quote:
            "Workflow SI by VRM AI Technology integrated seamlessly into our hiring process. The automated call scheduling and real-time transcripts gave our team full visibility. It is the most intuitive recruitment tool we have used."
    },
    {
        name: "Deepak Kumar",
        company: "V-Connect Systems",
        quote:
            "Workflow SI by VRM AI Technology streamlined our high-volume candidate outreach. Automated interview scheduling and instant status updates kept candidates engaged and reduced our drop-off rate by half."
    },
    {
        name: "Sandhya",
        company: "Nexus HR Solutions",
        quote:
            "Workflow SI by VRM AI Technology has revolutionized our screening process. The automated evaluation dashboard and real-time candidate ranking have given our recruitment team invaluable quality-of-hire insights we missed before."
    },
    {
        name: "Amir",
        company: "EduTech Global",
        quote:
            "Workflow SI by VRM AI Technology has been a game-changer for our high-volume hiring. The communication assessments and structured scoring are highly accurate and have greatly improved our quality of candidate selection."
    },
    {
        name: "Rajesh",
        company: "Aegis Solutions",
        quote:
            "With Workflow SI by VRM AI Technology, managing bulk candidate pipelines became incredibly seamless. The platform's automated skill matching and resume insights helped us fill critical engineering positions in record time."
    },
    {
        name: "Manish Gupta",
        company: "Talent Labs",
        quote:
            "Evaluating hundreds of developer resumes used to take weeks. Xpress Screening parses and ranks profiles based on core skills, making our candidate shortlisting process 4x faster."
    },
    {
        name: "Preethiksha",
        company: "SecureOps Systems",
        quote:
            "We were looking for a reliable way to monitor remote assessments. ScreenSage provided the exact balance of compliance and seamless candidate experience, boosting our hiring trust."
    },
    {
        name: "Vikram Malhotra",
        company: "Apex Solutions",
        quote:
            "Asynchronous interviews with VideoSage saved our managers hours of manual scheduling. The AI transcript summaries are incredibly precise and highlight key competencies."
    },
    {
        name: "Rohan Das",
        company: "Innovate Tech",
        quote:
            "CodeSage automated our technical evaluations with real-time test runs and quality insights. It gave us a fair way to screen applicants' clean-coding practices before scheduling live rounds."
    }
];

export const candidateTestimonials = [
    {
        name: "Priya",
        role: "Full Stack Developer Candidate",
        quote:
            "The interview flow felt structured and respectful. I completed one AI screening, answered role-specific questions, and got updates much faster than I expected."
    },
    {
        name: "Arun",
        role: "DevOps Engineer Candidate",
        quote:
            "VideoSage let me finish my interview on my own schedule without sacrificing quality. The questions were relevant, and the whole process felt organized and professional."
    },
    {
        name: "Meera",
        role: "Data Analyst Candidate",
        quote:
            "I appreciated the skill-based evaluation and clear scoring. Workflow SI by VRM AI Technology made the process feel merit-driven instead of random, which gave me more confidence as a candidate."
    },
    {
        name: "Rohit",
        role: "Software Engineer Candidate",
        quote:
            "CodeSage was a much better experience than puzzle-heavy coding rounds. The assessment felt practical, fair, and closely aligned with the actual role."
    },
    {
        name: "Sanjay Mehta",
        role: "Customer Support Candidate",
        quote:
            "Completing my initial interview via ScreenSage was extremely convenient. The instant scheduling and automated prep instructions made the recruitment process incredibly fast and user-friendly."
    },
    {
        name: "Ananya Rao",
        role: "Senior Software Engineer Candidate",
        quote:
            "Completing my technical evaluation through CodeSage was super easy. I could solve the coding challenges at my own convenience, and the compiler interface felt very clean and professional."
    },
    {
        name: "Divya Nair",
        role: "Customer Support Candidate",
        quote:
            "Taking the communication assessment with ScreenSage was amazing. The real-time feedback and structured voice prompts helped me showcase my language skills effectively."
    },
    {
        name: "Karthik Subramanian",
        role: "Product Management Candidate",
        quote:
            "Applying through the Workflow SI portal by VRM AI Technology was direct and transparent. I received immediate status updates on my application status, and the entire screening process felt organized and highly efficient."
    },
    {
        name: "Harish Pillai",
        role: "Frontend Developer Applicant",
        quote:
            "The profile parsing was spot on! It auto-filled my experience accurately, and the skills matching feedback showed me exactly how I aligned with the role requirements."
    },
    {
        name: "Neha shree",
        role: "QA Automation Engineer Candidate",
        quote:
            "I was nervous about screen monitoring during the assessment, but ScreenSage was unobtrusive and walked me through the permissions clearly. The process felt very secure."
    },
    {
        name: "Rahul",
        role: "Product Management Candidate",
        quote:
            "VideoSage made the video interview super convenient. I could record my answers at my own pace after work hours, and the interview instructions were extremely clear."
    },
    {
        name: "Sneha",
        role: "Backend Engineer Applicant",
        quote:
            "The coding round on CodeSage was very smooth. The editor supported hotkeys and the test suite ran quickly, giving me a much better experience than regular whiteboard rounds."
    }
];
